export var SceneEventList = ['loaded', 'maploaded', 'resize', 'destroy', 'dragstart', 'dragging', 'dragend', 'dragcancel'];
//# sourceMappingURL=ISceneService.js.map